import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { CSProcessPaymentAction } from '../controller/actions';
import { Grid, Header, Loader, Button } from 'semantic-ui-react';

export default function CSPaymentPage() {
    const dispatch = useDispatch();
    const query = useQuery();
    const csProcessPayment = useSelector((state) => state.csProcessPayment);
    const [invalidParams, setInvalidParams] = useState(false);

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const processPayment = () => {
        const region = query.get('Region') ? query.get('Region') : 'AU';
        const result = query.get('result') ? query.get('result') : null;
        const userid = query.get('userid') ? query.get('userid') : null;
        if (result && userid){
            dispatch(new CSProcessPaymentAction().processPayment(region, result, userid));
            
        } else {
            setInvalidParams(true);
        }
    };

    useEffect(() => {
        processPayment();
        // eslint-disable-next-line
    }, []);

    return (
        <Grid verticalAlign="middle" centered style={{'padding': '120px'}}>
            <Grid.Row>
                {
                    invalidParams === false && (csProcessPayment && csProcessPayment.loader) && 
          <Header size="large">Processing <Loader active inline /></Header>
                }
                {
                    csProcessPayment && csProcessPayment.failed === true &&
          <Header size="large">
              Process failed <br/><br/>
              <Button onClick={processPayment} basic color="black" content="Retry"/>

          </Header>
                }
                {
                    invalidParams === true &&
          <Header size="large">404 - Page not found</Header>
                }
            </Grid.Row>
        </Grid>
    );
}